/**
 * The application's shared document workspace instance — the ONE place yap's
 * open-document tab chrome comes from (`@suite/documents`, edited once
 * suite-wide). The bridge lives in `workspaces/DocumentTabArea.tsx`; document
 * identity comes from the app's own `state/useDocumentStore` (displayName,
 * kind, dirty, handle/vfs binding) and background tabs reopen through the
 * existing `openRecentDocument` pipeline.
 */

import { createDocumentWorkspace } from '@suite/documents';

export const documentWorkspace = createDocumentWorkspace({
  storageNamespace: 'yap',
  features: {
    dirtyDot: true,
    pinning: false,
    middleClickClose: true,
    shortcuts: true,
    overflowMenu: true,
  },
});
